<template>
    <div>
        <p class="pt-2">O score total é calculado como 1000 menos a média de todos os scores mais os valores configurados em
            global_settings ponderados.</p>
        <div class="row pl-1">
            <div class="col-md-3 score-item">
                <span class="score-label">Taxa de Estorno:</span>
                <span class="pl-1">{{ sellerScore.chargedback_fee ? sellerScore.chargedback_fee : 0 }}</span>
                <p>Calculada como a razão de vendas estornadas para o total de vendas (pagas + estornadas).</p>
            </div>
            <div class="col-md-3 score-item">
                <span class="score-label">Taxa de Reembolso:</span>
                <span class="pl-1">{{ sellerScore.refund_fee ? sellerScore.refund_fee : 0 }}</span>
                <p>Calculada como a razão de vendas reembolsadas para o total de vendas (pagas + reembolsadas).</p>
            </div>
            <div class="col-md-3 score-item">
                <span class="score-label">Média do Risco de Vendas:</span>
                <span class="pl-1">{{ sellerScore.avg_sales_risk_score ? sellerScore.avg_sales_risk_score : 0 }}</span>
                <p>Calculada como a média do risco de todas as vendas.</p>
            </div>
            <div class="col-md-3 score-item">
                <span class="score-label">Vendas Recusadas por Fraude:</span>
                <span class="pl-1">{{ sellerScore.percentage_sales_refused_fraud ?
                    sellerScore.percentage_sales_refused_fraud : 0 }}</span>
                <p>Calculada como a porcentagem de vendas recusadas devido a códigos de erro relacionados a fraudes.</p>
            </div>
            <div class="col-md-3 score-item">
                <span class="score-label">Vendas Recusadas por Dados Inválidos:</span>
                <span class="pl-1">{{ sellerScore.percentage_sales_refused_invalid_data ?
                    sellerScore.percentage_sales_refused_invalid_data : 0 }}</span>
                <p>Calculada como a porcentagem de vendas recusadas devido a códigos de erro de dados inválidos.</p>
            </div>
            <div class="col-md-3 score-item">
                <span class="score-label">Vendas Recusadas por Fundos Insuficientes:</span>
                <span class="pl-1">{{ sellerScore.percentage_sales_refused_insufficient_funds ?
                    sellerScore.percentage_sales_refused_insufficient_funds : 0 }}</span>
                <p>Calculada como a porcentagem de vendas recusadas devido a códigos de erro por fundos insuficientes.
                </p>
            </div>
            <div class="col-md-3 score-item">
                <span class="score-label">Taxa do Método de Pagamento:</span>
                <span class="pl-1">{{ sellerScore.payment_method_fee ? sellerScore.payment_method_fee : 0 }}</span>
                <p>Calculada como a porcentagem de vendas realizadas usando cartões de crédito.</p>
            </div>
            <div class="col-md-3 score-item">
                <span class="score-label">Valor da Oferta:</span>
                <span class="pl-1">{{ sellerScore.offer_amount ? sellerScore.offer_amount : 0 }}</span>
                <p>Calculada como o valor total de ofertas analisadas ativas multiplicado por 250.</p>
            </div>
            <div class="col-md-3 score-item">
                <span class="score-label">Pontuação de Fraude Detectada:</span>
                <span class="pl-1">{{ sellerScore.seller_score_fraud_detected ? sellerScore.seller_score_fraud_detected
                    : 0 }}</span>
                <p>Calculada como a porcentagem de vendas detectadas como fraude.</p>
            </div>
        </div>

    </div>
</template>

<script >
export default {
    props: {
        sellerScore: {
            type: Object,
            required: true
        }
    },

}
</script>

<style lang="scss" scoped>
.score-item {
    padding: 5px;    
    
}

.score-label {
    font-weight: bold;
}


.score-explanation {
    grid-column: 1 / -1;
    margin: 10px 0;
}
</style>